import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import './DrawerHeader.scss';

const DrawerHeader = (props) => {
  const { title, configuration } = props;
  const showTitle = !!title && (!configuration || (configuration.displayTitle !== false));
  return (
    <div className={`tuc-drawer-header ${showTitle ? 'tuc-drawer-header-titled' : 'tuc-drawer-header-untitled'}`}>
      {title && showTitle && <Typography variant="h6">{title}</Typography>}
    </div>
  );
};

DrawerHeader.propTypes = {
  title: PropTypes.string,
  configuration: PropTypes.shape({
    displayTitle: PropTypes.bool,
  }),
};

DrawerHeader.defaultProps = {
  title: undefined,
  configuration: undefined,
};

export default DrawerHeader;
